"use client";

import Link from "next/link";

import { links } from "@/data/links";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useVisitStripeBilling } from "@/features/stripe/services/visit-stripe-billing";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

export const FreeButton = () => {
  const { t, lang } = useLang();
  const { isAuthenticated, isFetchingUserData, profile } = useAuth();
  const isPaid = isAuthenticated && !(profile?.plan === "Free");
  const isEnterprise = profile?.authProvider === "Business";

  const {
    mutate: visitStripeBillingPage,
    isLoading: isLoadingStripeBillingPage,
  } = useVisitStripeBilling();

  if (isFetchingUserData) return <></>;

  if (isEnterprise)
    return (
      <Button variant="secondary" disabled className="w-full">
        {t.pricing.buttonText.enterprise}
      </Button>
    );

  // billing page
  if (isPaid)
    return (
      <Button
        isLoading={isLoadingStripeBillingPage}
        onClick={() => visitStripeBillingPage()}
        aria-label="go to stripe billing page"
        className="w-full"
      >
        {t.pricing.buttonText.chooseThisPlan}
      </Button>
    );

  return (
    <Link
      href={`/${lang}${links.myAnalysisSearch}`}
      aria-label="go to my analysis search page"
    >
      <Button
        variant="secondary"
        isLoading={isLoadingStripeBillingPage}
        className="w-full"
      >
        {t.pricing.buttonText.getStarted}
      </Button>
    </Link>
  );
};
